import React from 'react'
import { RouteObject, useRoutes } from 'react-router-dom'
import Login from '../pages/Login'
import Emails from '../pages/Emails/Emails'
import ViewEmailPage from '../pages/Emails/ViewEmail'
import Settings from '../pages/Settings/Settings'
import Customers from '../pages/Customers/Customers'
import Types from '../pages/Types/Types'


const Routes = () => {
    const routes: RouteObject[] = [
        {
            path: '/login',
            element: <Login />,
        },
        {
            path: '/emails',
            element: (
                <Emails
                    link={{
                        number: 0,
                        name: 'Emails',
                    }}
                />
            ),
        },
        {
            path: '/emails/:id/:slug?',
            element: <ViewEmailPage />,
        },
        {
            path: '/settings',
            element: <Settings />,
        },
        {
            path: '/customers',
            element: <Customers />,
        },
        {
            path: '/types',
            element: <Types />,
        },
        {
            path: '/',
            element: <Emails link={{ number: 0, name: 'Emails' }}/>,
        },
    ]

    return useRoutes(routes)
}

export default Routes
